import React from "react";
type EyebrowProps = {
  children: React.ReactNode;
  tone?: "light" | "dark" | "accent";
};
export function Eyebrow({
  children,
  tone = "light"
}: EyebrowProps) {
  const color = tone === "dark" ? "text-white/55" : tone === "accent" ? "text-accent" : "text-stone";
  return <p className={`flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.18em] ${color}`} data-id="element-80" data-mp="1gufr52ivjjso">
      <span aria-hidden="true" className="h-1.5 w-1.5 bg-accent" data-id="element-81" data-mp="11wx6ocd8bsr1" />
      {children}
    </p>;
}